import React, { useState } from 'react';

import CustomInputField from './input';
import CustomSelectField from './select';
import CustomApiSelectField from './apiSelect';
import CustomTextAreaField from './textArea';
import ArrayOfStringsBlock from './arrayOfStrings';
import CustomNumberInputField from './numberInput';
import CustomArrayOfCheckboxField from './arrayOfCheckbox';
import CustomCommentSection from "./comments";
import { getUIFieldTypeFromDataElement } from 'dsilo-ui-components';
import CustomDateRangePicker from './dateRangePicker';
import CustomCheckboxField from './checkbox';

const RenderFieldBasedOnType = (props) => {
    const { element } = props;    
    let currentType = getUIFieldTypeFromDataElement(element);
    
    return (
        <React.Fragment>
            {
                (function () {
                    switch (currentType) {
                        case "string":
                            return <CustomInputField key={element.type} {...props} />
                            break;
                        case "number":
                        case "currency":
                            return <CustomNumberInputField key={element.type} {...props} />
                            break;
                        case "select":
                        case "namepicker":
                            if (element?.isFetchAPI === true) {
                                return <CustomApiSelectField key={`${element.type}_api_${element.name || element.value}`} {...props} />
                            }
                            return <CustomSelectField key={element.type} {...props} />
                            break;
                        case "MultiCheckbox":
                            return <CustomArrayOfCheckboxField key={element.type} {...props} />
                            break;
                        case "textarea":
                            return <CustomTextAreaField key={element.type} {...props} />
                            break;
                        case "comments" :
                            return <CustomCommentSection key={element.type} {...props} />
                            break;
                        case "array":
                            return <ArrayOfStringsBlock key={element.type} {...props} />
                            break;
                        case "dateRange":
                            return <CustomDateRangePicker key={element.type} {...props} />
                            break;
                        case "checkbox":
                            return <CustomCheckboxField key={element.type} {...props} />
                            break;
                        default:
                            return <CustomInputField key={element.type} {...props} />
                            break;
                    }
                })()
            }
        </React.Fragment>
    )
}

export default RenderFieldBasedOnType